import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { EditUserForm } from '@/features/Users/EditUserForm'
import { useTranslation } from 'react-i18next'

type EditUserModalProps = {
  dialogProps: AlertDialogProps
  currentUserId: number
  onCloseModal: () => void
}

export const EditUserModal: FC<EditUserModalProps> = props => {
  const { dialogProps, currentUserId, onCloseModal } = props
  const { t } = useTranslation(['userManagement'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('userManagement:edit_user_modal_title')}</DialogTitle>
          <EditUserForm currentUserId={currentUserId} onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
